<div class="content">
    <form #schaltleitungDetailForm="ngForm" data-qa="settings-schaltleitung-create-form">

        <header>
            <div>
            </div>

            <div class="buttons">

                <button matButton="outlined"
                        type="button"
                        data-qa="close-details-button"
                        (click)="westnetzSidenavService.closeRightnav()">
                    <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                    Schließen
                </button>

                <button matButton="filled"
                        [disabled]="!schaltleitungDetailForm.form.valid"
                        type="button"
                        data-qa="create-schaltleitung-button"
                        (click)="saveSchaltleitung()">
                    <mat-icon>save</mat-icon>
                    {{ createNew ? 'Anlegen' : 'Speichern' }}
                </button>

                @if (!createNew) {
                    <button matButton="filled"
                            type="button"
                            class="button-warn"
                            data-qa="delete-schaltleitung-button"
                            (click)="deleteSchaltleitung(schaltleitung)">
                        <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                        Löschen
                    </button>
                }

            </div>
        </header>

        <div class="detail-main">

            <fieldset>
                <legend>Schaltleitung {{ createNew ? 'anlegen' : 'editieren' }}</legend>

                <mat-form-field>
                    <mat-label>Kürzel</mat-label>
                    <input matInput
                           maxlength="10"
                           #vorname="ngModel"
                           [(ngModel)]="schaltleitung.kuerzel"
                           id="kuerzel_{{schaltleitung.id}}"
                           name="kuerzel_{{schaltleitung.id}}"
                           data-qa="schaltleitung-kuerzel"
                           required/>
                    @if (vorname?.errors?.required) {
                        <mat-error>
                            Bitte tragen Sie das Kürzel der Schaltleitung ein
                        </mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput
                           maxlength="100"
                           #nachname="ngModel"
                           [(ngModel)]="schaltleitung.name"
                           id="name_{{schaltleitung.id}}"
                           name="name_{{schaltleitung.id}}"
                           data-qa="schaltleitung-name"
                           required/>
                    @if (nachname?.errors?.required) {
                        <mat-error>
                            Bitte tragen Sie den Namen der Schaltleitung ein
                        </mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>E-Mail</mat-label>
                    <input matInput
                           [tnbValidEmailList]=""
                           maxlength="255"
                           #email="ngModel"
                           [(ngModel)]="schaltleitung.email"
                           id="email_{{schaltleitung.id}}"
                           name="email_{{schaltleitung.id}}"
                           data-qa="schaltleitung-email"
                           required/>
                    @if (email?.errors?.required) {
                        <mat-error>
                            Bitte tragen Sie eine E-Mail-Adresse ein
                        </mat-error>
                    }
                    @if (email?.errors?.validEmailList) {
                        <mat-error>
                            Die Emailadressen müssen gültig sein.
                        </mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Adresse</mat-label>
                    <input matInput
                           maxlength="255"
                           #adresse="ngModel"
                           [(ngModel)]="schaltleitung.adresse"
                           id="adresse_{{schaltleitung.id}}"
                           data-qa="schaltleitung-adresse"
                           name="adresse_{{schaltleitung.id}}"/>
                </mat-form-field>

                <h3>Kontaktinformationen</h3>

                @for (kontakt of schaltleitung.kontakte; track kontakt; let i = $index) {
                    <div class="row">
                        <div class="column">
                            <mat-form-field>
                                <mat-label>Typ</mat-label>
                                <input matInput
                                       maxlength="100"
                                       #kontakttype="ngModel"
                                       [(ngModel)]="kontakt.type"
                                       id="schaltleitung_{{schaltleitung.id}}_kontakttype_{{i}}"
                                       name="schaltleitung_{{schaltleitung.id}}_kontakttype_{{i}}"/>
                                <mat-hint>Eine Beschreibung wie 'Telefon Notfall' oder 'E-Mail alternativ'</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="column">
                            <mat-form-field>
                                <mat-label>Wert</mat-label>
                                <input matInput
                                       maxlength="100"
                                       #kontaktdata="ngModel"
                                       [(ngModel)]="kontakt.data"
                                       id="schaltleitung_{{schaltleitung.id}}_kontaktdata_{{i}}"
                                       name="schaltleitung_{{schaltleitung.id}}_kontaktdata_{{i}}"/>
                                <mat-hint>Hier kann bspw. eine Telefonnummer oder eine E-Mail-Adresse stehen
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                }

                <button matButton="filled" (click)="addKontakt()">Neuer Eintrag</button>

            </fieldset>
        </div>
    </form>
</div>
